<template>
  <div class="flex flex-wrap mb-2" :style="guideStep >= 75 && guideStep <= 78  ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6" style="position:relative">
      <div class="flex">
        <div class="flex-none">
          <!-- <p class="shadowBox-title">訊息範本</p> -->
          <span class="text-red-500">*</span>
          <span class="text-grap-700 align-middle">{{lang['views']['Msg']['title']}}</span>
          <p class="ml-1.5 text-gray">{{lang['views']['Msg']['title_info']}}</p>
        </div>
        <div class="flex-grow text-right">
          <!-- 新手教學 -->
          <button @click="openModal" class="relative mr-2 button bg-blue" :class="{ 'ring-4 border-blue-400': guideStep === 76 }">
            <img
              class="mr-2 inline-block align-baseline"
              src="../assets/add.svg"
            />

            {{lang['views']['Msg']['add_button_text']}}
          </button>
          <button class="mr-2 button border-blue" :class="{ 'ring-4 border-blue-400': guideStep === 77 }" :disabled="editType == 1" @click="activeImmediate(selectedItem, 'edit')">{{lang['views']['Msg']['edit_button_text']}}</button>
          <button class="mr-2 button border-blue" :class="{ 'ring-4 border-blue-400': guideStep === 77 }" :disabled="editType == 2" @click="activeImmediate(selectedItem, 'copy')">{{lang['views']['Msg']['copy_button_text']}}</button>
        </div>
        <!-- <div v-if="editPageType" class="flex-grow text-right">
          <button class="mr-2 button border-blue" :disabled="editType == 2" @click="activeImmediate(selectedItem, 'browse')">瀏覽</button>
        </div> -->
      </div>

      <div class="px-4 py-2 mt-2 border-2 border-gray-ligth rounded-lg h-80">
        <div class="w-full h-full scrollbar-y">
          <div class="base-table">
            <template v-for="(item, value) in messageList" :key="value.id">
              <div class="table-body">
                <div class="max-w-10">
                  <!-- <Checkbox v-model="item.checked" :binary="true" /> -->
                  <RadioButton name="message" :value="item.id" v-model="selectedItem" @click="changeSelectItem(item.id)" />
                </div>
                <div class="w-80">{{ item.title }}</div>
                <!-- 新手教學 -->
                <div class="max-w-28" :class="{ 'ring-4 border-blue-400': guideStep === 78 }"><span :class="[item.status]" style="white-space:nowrap;"></span></div>
                <div class="max-w-40">{{ item.date }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
    <!-- 新手教學 -->
    <div v-if="guideStep >= 75 && guideStep <= 78" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0);"></div>

    <ModifyWindows v-model:show="showModal" size="xxl" :msgGuideStep="msgGuideStep">
      <template v-slot:header>
        <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['Dialog']['title']}}</span>
        <!-- 新手教學 -->
        <span class="p-input-icon-right w-1/6" :class="{ 'ring-4 border-blue-400': msgGuideStep === 701 }">
          <input
            v-model="messageName"
            ref="titleText"
            class="p-inputtext p-component w-40 underline-box w-11/12"
            type="text"
            :placeholder="lang['views']['Msg']['Dialog']['title_placeholder']"
          />
          <i
            @click="$refs.titleText.focus()"
            class="pi pi-pencil cursor-pointer"
          ></i>
        </span>
      </template>

      <template v-slot:content>
        <div class="relative flex h-full">
          <div class="flex-none">
            <!-- 新手教學 -->
            <ShadowBox :padding="false" class="w-96 h-full" :class="{ 'ring-4 border-blue-400': msgGuideStep === 702 }">
              <div class="flex flex-col h-full scrollbar-y">
                <p class="p-2 border-b font-semibold">{{lang['views']['Msg']['Dialog']['ShadowBox']['title']}}</p>

                <div class="flex-grow">
                  <template
                    v-for="(item, i) in getMsgLevelItem(
                      msgBox,
                      msgActive.level
                    )"
                    :key="i"
                  >
                    <div
                      v-if="
                        item.id == msgActive.id && item.level == msgActive.level
                      "
                    >
                      <div v-for="(cItem, c) in item.info" :key="c" class="p-2">
                        <div class="relative">
                          <template v-if="cItem.type === 'content'">
                            <div class="relative flex">
                              <div
                                v-on:click="swapMsgInfo(c, c - 1)"
                                class="flex-none pt-2 cursor-pointer"
                              >
                                <img src="../assets/up.svg" alt="" />
                              </div>
                              <div
                                v-on:click="swapMsgInfo(c, c + 1)"
                                class="flex-none pt-2 pr-1 cursor-pointer"
                              >
                                <img src="../assets/down.svg" alt="" />
                              </div>
                              <div class="flex-grow">
                                <!-- 新手教學 -->
                                <textarea
                                  :class="{ 'ring-4 border-blue-400': msgGuideStep === 708 }"
                                  v-if="cItem.editType != 'video'"
                                  v-model="cItem.content"
                                  @change="bezierRefresh"
                                  class="p-4 -mb-1 w-full bg-gray-light rounded-md"
                                  rows="2"
                                  :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['content']['content_placeholder']"
                                ></textarea>
                                <div
                                  v-for="(vItem, v) in cItem.imgVideo"
                                  :key="v"
                                  class="relative"
                                >
                                  <img
                                    v-if="vItem.img"
                                    :src="vItem.img"
                                    class="flex-grow w-full h-auto object-cover"
                                  />
                                  <img
                                    v-if="vItem.video"
                                    :src="vItem.video"
                                    class="flex-grow w-full h-auto object-cover"
                                  />
                                  <div class="relative">
                                    <!-- 新手教學 -->
                                    <FormInput
                                      v-if="vItem.img"
                                      v-model="vItem.title"
                                      :on-Change="bezierRefresh"
                                      :inputClass="['text-center',msgGuideStep === 725 ? 'ring-4 border-blue-400' : null ]"
                                      :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['content']['image_title_placeholder']"
                                    />
                                  </div>
                                </div>
                                <div
                                  v-for="(bItem, b) in cItem.btn"
                                  :key="b"
                                  class="relative"
                                >
                                  <div
                                    v-on:click="swapMsgInfoBtn(b, b - 1, cItem.id)"
                                    class="absolute top-4 left-3 z-10 cursor-pointer"
                                  >
                                    <img src="../assets/up.svg" alt="" />
                                  </div>
                                  <div
                                    v-on:click="swapMsgInfoBtn(b, b + 1, cItem.id)"
                                    class="absolute top-4 left-6 z-10 cursor-pointer"
                                  >
                                  <img src="../assets/down.svg" alt="" />
                                  </div>
                                  <i
                                    v-if="bItem.type != '1'"
                                    v-on:click="removeBotton(b, bItem.id, c)"
                                    class="pi pi-times absolute top-3 right-8 z-10 cursor-pointer text-gray-400"
                                  ></i>
                                  <!-- 新手教學 -->
                                  <i
                                    v-on:click="
                                      openContentInfoBtn(cItem.id, bItem.id)
                                    "
                                    class="pi pi-pencil absolute top-3 right-2 z-10 cursor-pointer text-gray-400"
                                    :class="{ 'ring-4 border-blue-400': msgGuideStep === 720 }"
                                  ></i>

                                  <!-- 新手教學 -->
                                  <FormInput
                                    v-model="bItem.text"
                                    :on-Change="bezierRefresh"
                                    :inputClass="['text-center',msgGuideStep === 727 ? 'ring-4 border-blue-400' : null ]"
                                    :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['content']['button_text_placeholder']"
                                  />
                                </div>

                                <!-- 新手教學 -->
                                <button
                                  @click="openContentTypeWindows(cItem.id, cItem.editType, cItem.btn.length)"
                                  class="button dashed w-full"
                                  :class="{ 'ring-4 border-blue-400': msgGuideStep === 715 || msgGuideStep === 728 }"
                                  v-if="msgActive.status != 'fast'"
                                >
                                  <!-- cItem.btn.push('') -->
                                  <img
                                    class="mr-2 inline-block align-baseline"
                                    src="../assets/add_gray.svg"
                                  />
                                  {{lang['views']['Msg']['Dialog']['ShadowBox']['content']['add_button_text']}}
                                </button>
                              </div>
                            </div>
                          </template>
                          <template v-else-if="cItem.type === 'img'">
                            <div class="relative flex">
                              <div
                                v-on:click="swapMsgInfo(c, c - 1)"
                                class="flex-none pt-2 cursor-pointer"
                              >
                                <img src="../assets/up.svg" alt="" />
                              </div>
                              <div
                                v-on:click="swapMsgInfo(c, c + 1)"
                                class="flex-none pt-2 pr-1 cursor-pointer"
                              >
                                <img src="../assets/down.svg" alt="" />
                              </div>

                              <div class="flex-grow">
                                <textarea
                                  v-if="cItem.editType != 'video'"
                                  v-model="cItem.content"
                                  @change="bezierRefresh"
                                  class="p-4 -mb-1 w-full bg-gray-light rounded-md"
                                  rows="2"
                                  :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['img']['content_placeholder']"
                                ></textarea>
                                <!-- <img
                                  :src="cItem.img"
                                  class="flex-grow mt-1 w-full h-auto object-cover rounded-t-xl rounded-b-none"
                                /> -->
                                <img
                                  :src="cItem.img"
                                  class="flex-grow w-full h-auto object-cover rounded-t-xl rounded-b-none"
                                />
                                <div class="relative">
                                  <FormInput
                                    v-model="cItem.title"
                                    :on-Change="bezierRefresh"
                                    inputClass="text-center"
                                    :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['img']['image_title_placeholder']"
                                  />
                                </div>
                                <div
                                  v-for="(bItem, b) in cItem.btn"
                                  :key="b"
                                  class="relative"
                                >
                                  <div
                                    v-on:click="swapMsgInfoBtn(b, b - 1, cItem.id)"
                                    class="absolute top-4 left-3 z-10 cursor-pointer"
                                  >
                                    <img src="../assets/up.svg" alt="" />
                                  </div>
                                  <div
                                    v-on:click="swapMsgInfoBtn(b, b + 1, cItem.id)"
                                    class="absolute top-4 left-6 z-10 cursor-pointer"
                                  >
                                    <img src="../assets/down.svg" alt="" />
                                  </div>
                                  <i
                                    v-if="bItem.type != '1'"
                                    v-on:click="removeBotton(b, bItem.id)"
                                    class="pi pi-times absolute top-3 right-8 z-10 cursor-pointer text-gray-400"
                                  ></i>
                                  <i
                                    v-on:click="
                                      openContentInfoBtn(cItem.id, bItem.id)
                                    "
                                    class="pi pi-pencil absolute top-4 right-2 z-10 cursor-pointer text-gray-400"
                                  ></i>

                                  <FormInput
                                    v-model="bItem.text"
                                    :on-Change="bezierRefresh"
                                    inputClass="text-center"
                                    :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['img']['button_text_placeholder']"
                                  />
                                </div>

                                <button
                                  @click="openContentInfoBtn(cItem.id)"
                                  class="button dashed w-full"
                                >
                                  <!-- cItem.btn.push('') -->
                                  <img
                                    class="mr-2 inline-block align-baseline"
                                    src="../assets/add_gray.svg"
                                  />
                                  {{lang['views']['Msg']['Dialog']['ShadowBox']['img']['add_button_text']}}
                                </button>
                              </div>
                            </div>
                          </template>
                          <template v-else-if="cItem.type === 'video'">
                            <div class=" relative flex">
                              <div
                                v-on:click="swapMsgInfo(c, c - 1)"
                                class="flex-none pt-2 cursor-pointer"
                              >
                                <img src="../assets/up.svg" alt="" />
                              </div>
                              <div
                                v-on:click="swapMsgInfo(c, c + 1)"
                                class="flex-none pt-2 pr-1 cursor-pointer"
                              >
                                <img src="../assets/down.svg" alt="" />
                              </div>

                              <div class="flex-grow">
                                <img
                                  v-if="cItem.video"
                                  :src="cItem.video"
                                  class="flex-grow mt-1 w-full h-auto object-cover rounded-t-xl rounded-b-none"
                                />
                                <div
                                  v-for="(vItem, v) in cItem.imgVideo"
                                  :key="v"
                                  class="relative"
                                >
                                  <img
                                    v-if="vItem.video"
                                    :src="vItem.video"
                                    class="flex-grow mt-1 w-full h-auto object-cover rounded-t-xl rounded-b-none"
                                  />
                                </div>
                                <!-- <div class="relative">
                                  <FormInput
                                    v-model="cItem.title"
                                    :on-Change="bezierRefresh"
                                    inputClass="text-center"
                                    placeholder="請輸入影片標題"
                                  />
                                </div> -->
                                <div
                                  v-for="(bItem, b) in cItem.btn"
                                  :key="b"
                                  class="relative"
                                >
                                  <div
                                    v-on:click="swapMsgInfoBtn(b, b - 1, cItem.id)"
                                    class="absolute top-4 left-3 z-10 cursor-pointer"
                                  >
                                    <img src="../assets/up.svg" alt="" />
                                  </div>
                                  <div
                                    v-on:click="swapMsgInfoBtn(b, b + 1, cItem.id)"
                                    class="absolute top-4 left-6 z-10 cursor-pointer"
                                  >
                                    <img src="../assets/down.svg" alt="" />
                                  </div>
                                  <i
                                    v-if="bItem.type != '1'"
                                    v-on:click="removeBotton(b, bItem.id)"
                                    class="pi pi-times absolute top-3 right-8 z-10 cursor-pointer text-gray-400"
                                  ></i>
                                  <i
                                    v-on:click="
                                      openContentInfoBtn(cItem.id, bItem.id)
                                    "
                                    class="pi pi-pencil absolute top-4 right-2 z-10 cursor-pointer text-gray-400"
                                  ></i>
                                  <FormInput
                                    v-model="bItem.text"
                                    :on-Change="bezierRefresh"
                                    inputClass="text-center"
                                    :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['video']['button_text_placeholder']"
                                  />
                                </div>

                                <button
                                  @click="openContentInfoBtn(cItem.id)"
                                  class="button dashed w-full"
                                >
                                  <!-- cItem.btn.push('') -->
                                  <img
                                    class="mr-2 inline-block align-baseline"
                                    src="../assets/add_gray.svg"
                                  />
                                  {{lang['views']['Msg']['Dialog']['ShadowBox']['video']['add_button_text']}}
                                </button>
                              </div>
                            </div>
                          </template>

                          <!-- <div v-if="c > 0" class="absolute top-2 right-1"> -->
                          <div class="absolute top-2 right-1">
                            <div
                              @click="removeMsgBoxInfoConfirmed(cItem.id)"
                              class="p-2 bg-gray-300 rounded-md cursor-pointer"
                            >
                              <img src="../assets/clear.svg" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="(item.isFirst != true || item.info.length == 0)" class="flex p-1">
                        <div v-if="msgActive.status != 'fast'" class="flex-grow p-1">
                          <button
                            @click="openMsgBoxImg(null)"
                            class="button dashed w-full"
                          >
                            <img
                              class="mr-2 inline-block align-baseline"
                              src="../assets/img.svg"
                            />
                            {{lang['views']['Msg']['Dialog']['ShadowBox']['info']['add_image']}}
                          </button>
                        </div>
                        <div v-if="msgActive.status != 'fast'" class="flex-grow p-1">
                          <button
                            @click="openMsgBoxVideo(null)"
                            class="button dashed w-full"
                          >
                            <img
                              class="mr-2 inline-block align-baseline"
                              src="../assets/video.svg"
                            />{{lang['views']['Msg']['Dialog']['ShadowBox']['info']['add_video']}}
                          </button>
                        </div>
                        <div class="flex-grow p-1">
                          <button
                            @click="setMsgBoxContent"
                            class="button dashed w-full"
                          >
                            <img
                              class="mr-2 inline-block align-baseline"
                              src="../assets/content.svg"
                            />{{lang['views']['Msg']['Dialog']['ShadowBox']['info']['add_text']}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="p-2 text-right border-b">
                  <template
                    v-for="(item, i) in getMsgLevelItem(
                      msgBox,
                      msgActive.level,
                      msgActive.status
                    )"
                    :key="i"
                  >
                    <div
                      v-for="(fItem, f) in item.fast"
                      v-if="item.id == msgActive.id && item.level == msgActive.level"
                      :key="f"
                      class="flex mb-2"
                    >
                      <div
                        v-on:click="swapMsgFast(f, f - 1)"
                        class="relative flex-none py-3 pl-1 cursor-pointer"
                      >
                        <img src="../assets/up.svg" alt="" />
                      </div>
                      <div
                        v-on:click="swapMsgFast(f, f + 1)"
                        class="relative flex-none py-3 pr-1 cursor-pointer"
                      >
                        <img src="../assets/down.svg" alt="" />
                      </div>
                      <!-- 新手教學 -->
                      <div class="flex-grow" :class="{ 'ring-4 border-blue-400': msgGuideStep === 710 }">
                        <FormInput
                          v-model="fItem.text"
                          :on-Change="bezierRefresh"
                          inputClass="text-center rounded-full"
                          :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['quickly']['title_placeholder']"
                        />
                      </div>
                      <div class="flex-none p-2">
                        <!-- 新手教學 -->
                        <div
                          :class="{ 'ring-4 border-blue-400': msgGuideStep === 711 }"
                          @click="removeMsgBoxFastConfirmed(fItem.id)"
                          class="p-2 bg-gray-300 rounded-md cursor-pointer"
                        >
                          <img src="../assets/clear.svg" />
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- 新手教學 -->
                  <button v-if="msgActive.status != 'general'" @click="setMsgBoxItemFast('','')" :class="{ 'ring-4 border-blue-400': msgGuideStep === 707 || msgGuideStep === 709 }" class="button border-gray">
                    {{lang['views']['Msg']['Dialog']['ShadowBox']['quickly']['add_button_text']}}
                  </button>
                </div>
                <div class="p-4 text-right">
                  <div
                    class="p-5 border border-gray bg-gray-light rounded-full"
                  ></div>
                </div>
              </div>
            </ShadowBox>
          </div>
          <!-- 新手教學 -->
          <div class="relative flex-grow w-full scrollbar-x" :class="{ 'ring-4 border-blue-400': msgGuideStep === 703 }">
            <div class="relative flex w-full h-full scrollbar-y">
              <div id="ropebag"></div>
              <!-- 新手教學 -->
              <MsgBox
                v-for="(item, i) in msgBox.item"
                v-bind:lang="lang"
                :msgGuideStep="msgGuideStep"
                :key="i"
                :msgdata="msgBox"
                :msgactive="msgActive"
                :setMsgActive="setMsgActive"
                :removeMsgBox="removeMsgBoxConfirmed"
              />
            </div>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <div class="text-right">
          <button class="button bg-blue" style="margin-right:48px;" @click="save()">{{lang['views']['Msg']['Dialog']['ShadowBox']['save_button']}}</button>
          <button v-if="false" class="button bg-yellow">{{lang['views']['Msg']['Dialog']['ShadowBox']['finish_button']}}</button>
        </div>
      </template>
    </ModifyWindows>

    <ModifyWindows v-model:show="showContentWindows" size="xs" :msgGuideStep="msgGuideStep">
      <template v-slot:header>
        <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['info_type_Dialog']['edit_title']}}</span>
        <!-- <span v-if="editPageType" class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['info_type_Dialog']['view_title']}}</span> -->
      </template>

      <template v-slot:content>
        <div class="p-2 w-full h-full">
          <!-- 新手教學 -->
          <FormInput
            v-model="contentInfoBtn.text"
            :inputClass="['mt-2 text-center', msgGuideStep === 718 ? 'ring-4 border-blue-400' : null]"
            :placeholder="lang['views']['Msg']['info_type_Dialog']['button_name_placeholder']"
          />
          <!-- 新手教學 -->
          <FormInput
            v-if="contentInfoBtn.active === 2 || msgGuideStep === 731"
            v-model="contentInfoBtn.url"
            :inputClass="['mt-2 text-center', msgGuideStep === 731 ? 'ring-4 border-blue-400' : null]"
            :placeholder="lang['views']['Msg']['info_type_Dialog']['link_placeholder']"
          />
          <!-- 新手教學 -->
          <FormInput
            v-if="contentInfoBtn.active === 3 || msgGuideStep === 734"
            v-model="contentInfoBtn.phone"
            :inputClass="['mt-2 text-center', msgGuideStep === 734 ? 'ring-4 border-blue-400' : null]"
            oninput="value=value.replace(/[^\d]/g,'')"
            placeholder="ex：0912345678 or 886912345678"
          />

          <p class="mt-4 font-semibold">{{lang['views']['Msg']['info_type_Dialog']['block_info']}}</p>
          <!-- 新手教學 -->
          <button
            @click="setNewNode()"
            :class="{ active: contentInfoBtn.active == 1, 'ring-4 border-blue-400': msgGuideStep === 717 }"
            class="mt-2 button dashed w-full"
          >
            <i class="mr-2 pi pi-align-left"></i>
            {{lang['views']['Msg']['info_type_Dialog']['add_node']}}
          </button>
          <!-- 新手教學 -->
          <button
            @click="contentInfoBtn.active = 2"
            :class="{ active: contentInfoBtn.active == 2 || msgGuideStep === 730 || msgGuideStep === 731, 'ring-4 border-blue-400': msgGuideStep === 731 }"
            class="mt-2 button dashed w-full"
          >
            <i class="mr-2 pi pi-link"></i>
            {{lang['views']['Msg']['info_type_Dialog']['add_link']}}
          </button>
          <!-- 新手教學 -->
          <button
            @click="contentInfoBtn.active = 3"
            :class="{ active: contentInfoBtn.active == 3 || msgGuideStep === 733 || msgGuideStep === 734, 'ring-4 border-blue-400': msgGuideStep === 734 }"
            class="mt-2 button dashed w-full"
          >
            <i class="mr-2 pi pi-phone"></i>
            {{lang['views']['Msg']['info_type_Dialog']['add_phone']}}
          </button>
        </div>
      </template>

      <template v-slot:footer>
        <div class="text-right">
          <button @click="showContentWindows = false" class="button bg-yellow">
            {{lang['views']['Msg']['info_type_Dialog']['cancel_button']}}
          </button>
          <!-- 新手教學 -->
          <button @click="setMsgBoxItemBtn()" class="button bg-yellow" :class="{ 'ring-4 border-blue-400': msgGuideStep === 719 }">
            {{lang['views']['Msg']['info_type_Dialog']['yes_button']}}
          </button>
        </div>
      </template>
    </ModifyWindows>

    <ModifyWindows v-model:show="showContentTypeWindows" size="xs" :msgGuideStep="msgGuideStep">
      <template v-slot:header>
        <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['select_info_type_Dialog']['title']}}</span>
      </template>

      <template v-slot:content>
        <div class="p-2 w-full h-full">
          <div class="flex-grow p-1">
            <!-- 新手教學 -->
            <button
              @click="openMsgBoxImg(contentInfoTypeWindowsId, contentInfoTypeWindowsEditType)"
              :class="{ 'ring-4 border-blue-400': msgGuideStep === 724 }"
              class="button dashed w-full"
              :disabled="contentInfoTypeWindowsEditType == 'video' && contentInfoTypeWindowsEditType != 'text'"
            >
              <img
                class="mr-2 inline-block align-baseline"
                src="../assets/img.svg"
              />
              {{lang['views']['Msg']['select_info_type_Dialog']['add_image']}}
            </button>
          </div>
          <div class="flex-grow p-1">
            <!-- 新手教學 -->
            <button
              :class="{ 'ring-4 border-blue-400': msgGuideStep === 722 }"
              @click="openMsgBoxVideo(contentInfoTypeWindowsId, contentInfoTypeWindowsEditType)"
              class="button dashed w-full"
              :disabled="contentInfoTypeWindowsEditType == 'img' && contentInfoTypeWindowsEditType != 'text'"
            >
              <img
                class="mr-2 inline-block align-baseline"
                src="../assets/video.svg"
              />{{lang['views']['Msg']['select_info_type_Dialog']['add_video']}}
            </button>
          </div>
          <div class="flex-grow p-1">
            <!-- 新手教學 -->
            <button
              :class="{ 'ring-4 border-blue-400': msgGuideStep === 718 }"
              @click="openContentInfoBtn(contentInfoTypeWindowsId)"
              class="button dashed w-full"
              :disabled="nodeBottonNum >= 3"
            >
              <img
                class="mr-2 inline-block align-baseline"
                src="../assets/content.svg"
              />{{lang['views']['Msg']['select_info_type_Dialog']['add_button_text']}}
            </button>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <div class="text-right">
          <button
            @click="showContentTypeWindows = false"
            class="button bg-yellow"
          >
            {{lang['views']['Msg']['select_info_type_Dialog']['cancel_button']}}
          </button>
          <button @click="setMsgBoxItemBtn()" class="button bg-yellow">
            {{lang['views']['Msg']['select_info_type_Dialog']['yes_button']}}
          </button>
        </div>
      </template>
    </ModifyWindows>

    <!-- <ModifyWindows v-model:show="showImgWindows" size="sm"> -->
    <ModifyWindows v-model:show="showImgWindows" :msgGuideStep="msgGuideStep">
      <template v-slot:header>
        <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['image_Dialog']['title']}}</span>
        <button @click="$refs.imgUpload.click()" class="button border-blue">
          <img
            class="mr-2 inline-block align-baseline"
            src="../assets/upload.svg"
          />{{lang['views']['Msg']['image_Dialog']['upload']}}
        </button>
        <input ref="imgUpload" type="file" class="hidden" @change="onImgUpload($event)" />
        <button @click="imageUpdate()" class="ml-3 button border-blue">
          {{lang['views']['Msg']['image_Dialog']['update']}}
        </button>
      </template>

      <template v-slot:content>
        <div style="height: 325px; position:relative">
          <loading :active="!showImgLoading"
                  :can-cancel="true"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'">
          </loading>
          <span class="text-grap-700 align-middle">{{lang['views']['Msg']['image_Dialog']['upload_block_title']}}</span>
          <div class="flex flex-wrap p-2 w-full h-auto scrollbar-y">
            <template
              v-for="(item, i) in img.imgList"
              :key="i">
              <img
                @click="selectImg(i, 'upload')"
                :class="{ 'border-blue-light': img.active == i }"
                :src="img.imgList[i].url"
                class="
                  flex-none
                  m-2
                  mb-4
                  w-24
                  h-24
                  border-4 border-transparent
                  object-cover
                  rounded-xl
                  cursor-pointer
                  relative
                "
              />
              <div class="bg-gray-300 rounded-md relative cursor-pointer" :style="'top:12px; left: -28px; height:20px;'" @click="deleteUpload(img.imgList[i].ctm_media, 'image')">
                <img src="../assets/clear.svg" width="15" />
              </div>
            </template>
          </div>
          <span class="text-grap-700 align-middle">{{lang['views']['Msg']['image_Dialog']['facebook_block_title']}}</span>
          <div class="flex flex-wrap p-2 w-full h-auto scrollbar-y">
            <img
              v-for="(item, i) in img.imgListApi"
              :key="i"
              @click="selectImg(i, 'api')"
              :class="{ 'border-blue-light': img.activeApi == i }"
              :src="img.imgListApi[i].url"
              class="
                flex-none
                m-2
                mb-4
                w-24
                h-24
                border-4 border-transparent
                object-cover
                rounded-xl
                cursor-pointer
              "
            />
          </div>
          <span v-if="img.imgListApi.length <= 0" class="text-grap-700 align-middle ml-5">{{lang['views']['Msg']['image_Dialog']['empty_block_title']}}</span>
        </div>
      </template>

      <template v-slot:footer>
        <div class="text-right">
          <button @click="setMsgBoxImg" class="button bg-yellow" style="margin-right:48px;">{{lang['views']['Msg']['image_Dialog']['yes_button']}}</button>
        </div>
      </template>
    </ModifyWindows>

    <!-- <ModifyWindows v-model:show="showVideoWindows" size="sm"> -->
    <ModifyWindows v-model:show="showVideoWindows" :msgGuideStep="msgGuideStep">
      <template v-slot:header>
        <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['video_Dialog']['title']}}</span>
        <button @click="$refs.videoUpload.click()" class="button border-blue" v-if="this.msgActive.level != 0">
          <img
            class="mr-2 inline-block align-baseline"
            src="../assets/upload.svg"
          />{{lang['views']['Msg']['video_Dialog']['upload']}}
        </button>
        <input ref="videoUpload" type="file" class="hidden" @change="onVideoUpload($event)" />
        <button @click="videoUpdate()" class="ml-3 button border-blue">
          {{lang['views']['Msg']['video_Dialog']['update']}}
        </button>
      </template>

      <template v-slot:content>
        <div style="height: 325px; position:relative">
          <loading :active="!showVideoLoading"
                  :can-cancel="true"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'">
          </loading>
          <span class="text-grap-700 align-middle">{{lang['views']['Msg']['video_Dialog']['upload_block_title']}}</span>
          <div class="flex flex-wrap p-2 w-full h-auto scrollbar-y">
            <template
              v-for="(item, i) in video.videoList"
              :key="i">
                <img
                  @click="selectVideo(i, 'upload')"
                  :class="{ 'border-blue-light': video.active == i }"
                  :src="video.videoList[i].url"
                  class="
                    flex-none
                    m-2
                    mb-4
                    w-24
                    h-24
                    border-4 border-transparent
                    object-cover
                    rounded-xl
                    cursor-pointer
                    relative
                  "
                />
                <div class="bg-gray-300 rounded-md relative cursor-pointer" :style="'top:12px; left: -28px; height:20px;'" @click="deleteUpload(video.videoList[i].ctm_media, 'video')">
                  <img src="../assets/clear.svg" width="15" />
                </div>
            </template>
          </div>
          <span class="text-grap-700 align-middle">{{lang['views']['Msg']['video_Dialog']['facebook_block_title']}}</span>
          <div class="flex flex-wrap p-2 w-full h-auto scrollbar-y">
            <img
              v-for="(item, i) in video.videoListApi"
              :key="i"
              @click="selectVideo(i, 'api')"
              :class="{ 'border-blue-light': video.activeApi == i }"
              :src="video.videoListApi[i].url"
              class="
                flex-none
                m-2
                mb-4
                w-24
                h-24
                border-4 border-transparent
                object-cover
                rounded-xl
                cursor-pointer
              "
            />
          </div>
          <span v-if="video.videoListApi.length <= 0" class="text-grap-700 align-middle ml-5">{{lang['views']['Msg']['video_Dialog']['empty_block_title']}}</span>
        </div>
      </template>

      <template v-slot:footer>
        <div class="text-right">
          <button @click="setMsgBoxVideo" class="button bg-yellow" style="margin-right:48px;">{{lang['views']['Msg']['video_Dialog']['yes_button']}}</button>
        </div>
      </template>
    </ModifyWindows>
    <!-- 新手教學 -->
    <Mask :isDisplay="msgGuideStep > -1 && msgGuide" />
    <!-- msgGuideStep s-->
    <MsgGuideTips
      v-if="msgGuideStep >= 701 && msgGuide"
      :nowStep="msgGuideStep"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <!-- msgGuideStep e-->
  </div>
</template>
<script>
import { ref } from 'vue'
// import Header from "@/components/Header.vue";
// <!-- 新手教學 -->
import Mask from '@/components/Event/Mask.vue';
import MsgGuideTips from '@/components/Tips/MsgGuideTips.vue';
// <!-- 新手教學 -->
import ShadowBox from "@/components/ShadowBox.vue";
import ModifyWindows from "@/components/ModifyWindows.vue";
import Checkbox from "primevue/checkbox";
import RadioButton from "primevue/radiobutton";
import MsgBox from "@/components/MsgBox.vue";
import FormInput from "@/components/Form/Input.vue";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import axios from 'axios'
import Qs from 'qs'

const messageName = ref('');

export default {
  name: "Msg",
  components: {
    // <!-- 新手教學 -->
    Mask,
    MsgGuideTips,
    // <!-- 新手教學 -->
    // Header,
    ShadowBox,
    ModifyWindows,
    Checkbox,
    RadioButton,
    MsgBox,
    FormInput,
    Swal,
    Loading,
  },
  props: {
    // <!-- 新手教學 -->
    guideStep: {
      type: Number,
      default: -1
    },
    // <!-- 新手教學 -->
    editPage: {
      type: Boolean
    },
    pageId: {
      type:String
    },
    goalsObjective:{
      type:String
    },
    messageId: {
      type:String
    },
    firstMessageId: {
      type:String
    },
    messageStatus: {
      type:String
    },
    useTeachDetail: {
      type: Boolean,
      default: false
    },
    targetAllSkip:{
      type: Number
    },
    msgTeachingOver: {
      type: Boolean
    },
    teachingId: {
      type: Number,
      default: -1
    },
    campaignId: {
      type: Number,
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      // <!-- 新手教學 -->
      msgTeaching_id: 0,
      msgTeachingOverData: 0,
      msgGuideStep: -1,
      msgGuide: true,
      // <!-- 新手教學 -->
      showMsgList: false,
      showModal: false,
      showImgWindows: false,
      showVideoWindows: false,
      showContentWindows: false,
      showContentTypeWindows: false,
      contentInfoTypeWindowsId: null,
      showImgLoading: true,
      showVideoLoading: true,
      nodeBottonNum: 0,
      contentInfoTypeWindowsEditType: 'text',
      nodeId: 3,
      view_type: 'copy',
      contentInfoBtn: {
        text: "",
        url: "",
        phone: "",
        active: 1,
        contentId: null,
        btnId: null
      },
      messageList: [],
      editType: 0,
      selectedItem: null,
      data: [
        {
          checked: false,
          title: "訊息一",
          status: "formal",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息二",
          status: "draft",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息三",
          status: "error",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息四",
          status: "formal",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息五",
          status: "draft",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息六",
          status: "error",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息七",
          status: "formal",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息八",
          status: "draft",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息九",
          status: "error",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息十",
          status: "formal",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息十一",
          status: "draft",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息十二",
          status: "error",
          date: "2021-05-20"
        }
      ],

      msgActive: {
        id: 0,
        level: 0,
        status: 'first'
      },
      msgBox: {},
      img: {
        active: null,
        activeApi: null,
        imgList: [],
        imgListApi: []
      },
      video: {
        active: null,
        activeApi: null,
        videoList: [],
        videoListApi: []
      },
      // img: {
      //   active: null,
      //   activeApi: null,
      //   imgList: [
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg",
      //     "./img.jpg"
      //   ],
      //   imgListApi: []
      // },
      // video: {
      //   active: null,
      //   activeApi: null,
      //   videoList: [
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg",
      //     "./video.jpg"
      //   ],
      //   videoListApi: []
      // }
    };
  },
  watch:{
    'lang':function(v){
    //  console.log('msg this.lang');
    //  console.log(this.lang);

      this.msgBox = {
        item: [
          {
            id: 0,
            level: 0,
            isFirst: true,
            status:'first',
            info: [
              {
                id: 2,
                editType: 'text',
                content: this.lang['views']['Msg']['msgBox_item_info_content'],
                btn: [],
                imgVideo: [],
                type: "content"
              }
            ],
            fast: []
          }
        ],
        sub: {}
      };
    },
    // <!-- 新手教學 -->
    msgTeachingOver(value){
    //  console.log('b msgTeachingOverData');
    //  console.log(value);
    //  console.log(this.msgTeachingOverData);

      if(value != '' && value != null && typeof value != 'undefined'){
        let get_value = value.split('_');

      //  console.log(get_value);

        this.msgTeachingOverData = parseInt(get_value[0])

      //  console.log('b this.msgGuide');
      //  console.log(this.msgGuide);
        if(this.msgTeachingOverData == 0){
          this.msgGuide = true
        }
      //  console.log('a this.msgGuide');
      //  console.log(this.msgGuide);
      }

    //  console.log('a msgTeachingOverData');
    //  console.log(this.msgTeachingOverData);
    },
    showModal(val) {
      if (!val) {
      //  console.log('!val');
        this.msgGuideStep = -1;
        this.$router.push({ query: { step: this.msgGuideStep, msgguide: false }});

        this.showFormList = true;

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
            s_code: this.$route.params.id,
            page_id: this.pageId,
          }))
          .then((response) => {
            if(response.data.status == 'success'){

              this.messageList = response.data.return_data
              this.showFormList = false;
            }
          });
      } else {
      //  console.log('val');
        if (this.$route.query.msgguide) {
          this.msgGuide = this.$route.query.msgguide === 'false' ? false : true;
          this.msgGuideStep = this.$route.query.msgguide === 'false' ? -1 : 701;
          this.$router.push({ query: { step: this.msgGuideStep, msgguide: false }});
        }
      }
    },
    msgGuideStep(val) {
      if (val === 707) {
        let text_707_1 = this.lang['views']['Msg']['watch']['msgGuideStep']['707_setMsgBoxItemFast_1'];
        let text_707_2 = this.lang['views']['Msg']['watch']['msgGuideStep']['707_setMsgBoxItemFast_2'];

        this.setMsgBoxItemFast(text_707_1, text_707_2);
      }

      if (val === 708) {
        let itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
        let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);
        let content_708 = this.lang['views']['Msg']['watch']['msgGuideStep']['708_content'];

        itemList[index].info[0].content = content_708;
      }

      if (val === 716) {
        this.showContentTypeWindows = true;
      }

      if (val === 717) {
        this.openContentInfoBtn(2);
      }

      if (val === 718) {
        let content_718 = this.lang['views']['Msg']['watch']['msgGuideStep']['718_contentInfoBtn_text'];

        this.contentInfoBtn.text = content_718;
      }

      if (val === 720) {
        this.setMsgBoxItemBtn();
      }

      if (val === 722) {
        this.showContentTypeWindows = true;
      }

      if (val === 723) {
        this.setFakeImage();
        this.showContentTypeWindows = false;
      }

      if (val === 724) {
        this.showContentTypeWindows = true;
      }

      if (val === 725) {
        this.showContentTypeWindows = false;
      }

      if(val === 726){
        let itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
        let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);
        itemList[index].info[0].imgVideo = [];
      }

      if (val === 730) {
        this.contentInfoBtn.active = 2;
        this.openContentInfoBtn(2);
      }

      if (val === 731) {
        let content_731 = this.lang['views']['Msg']['watch']['msgGuideStep']['731_contentInfoBtn_text'];

        this.contentInfoBtn.active = 2;
        this.contentInfoBtn.text = content_731;
        this.contentInfoBtn.url = 'https://www.autoturn.net/index.php/index/view';
      //  console.log(this.contentInfoBtn);
      }

      if (val === 732) {
         this.setMsgBoxItemBtn();
      }

      if (val === 733) {
        this.contentInfoBtn.active = 3;
        this.openContentInfoBtn(2);
      }

      if (val === 734) {
        let content_734 = this.lang['views']['Msg']['watch']['msgGuideStep']['734_contentInfoBtn_text'];

        this.contentInfoBtn.active = 3;
        this.contentInfoBtn.text = content_734;
        this.contentInfoBtn.url = '';
        this.contentInfoBtn.phone = '0912345678';
      //  console.log(this.contentInfoBtn);
      }

      if (val === 735) {
        this.setMsgBoxItemBtn();
      }
    },
    // <!-- 新手教學 -->
    pageId(v){
    //  console.log('form pageId');
    //  console.log(v);
      this.showFormList = true;

      axios
        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: v,
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            // console.log('b this.messageList');
            // console.log(this.messageList);

            this.messageList = response.data.return_data

            this.showFormList = false;

            // console.log('a this.messageList');
            // console.log(this.messageList);
          }
        });
    },
    messageId(v){
    //  console.log('messageId:'+v);

      // console.log('a selectedItem:'+this.selectedItem);


      if(v != '' && v != null && typeof v != 'undefined'){
        let get_value = v.split('_');

      //  console.log(get_value);

        this.selectedItem = parseInt(get_value[0])
      } else {
        this.selectedItem = []
      }

      // console.log('b selectedItem:'+this.selectedItem);
    },
    firstMessageId(v){
    //  console.log('firstMessageId:'+v);

      // console.log('a selectedItem:'+this.selectedItem);

      if(v != '' && v != null && typeof v != 'undefined'){
        this.selectedItem = v
      } else {
        this.selectedItem = []
      }

      // console.log('b selectedItem:'+this.selectedItem);
    },
    messageStatus(v){
      this.editType = 2

      if(v == 'Y'){
        this.editType = 1
      }
    }
  },
  created() {
  //  console.log('created');
  //  console.log(this.pageId);

    if(this.pageId != '' && this.pageId != null && typeof this.pageId != 'undefined'){
      this.showFormList = true;
    //  console.log('do messages');
      axios
        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: this.pageId,
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            // console.log('b this.messageList');
            // console.log(this.messageList);

            this.messageList = response.data.return_data

            this.showFormList = false;
            // console.log('a this.messageList');
            // console.log(this.messageList);
          }
        });
    }
  },
  mounted() {
    // 註冊貝茲曲線
    // eslint-disable-next-line no-undef
    $(".element").bezier({ animate: false });
    // <!-- 新手教學 -->
    if (this.$route.query.msgguide) {
      this.msgGuide = this.$route.query.msgguide === 'false' ? false : true;
    }
  },
  methods: {
    // <!-- 新手教學 -->
    setFakeImage() {

      let itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);
      itemList[index].info[0].imgVideo = [];

      // itemList[index].info[0].imgVideo.push({
      //   id: 1,
      //   img: 'https://res.cloudinary.com/dj1uuawxw/image/upload/v1622275197/wdge0wplcjohmvrhtm7z.jpg',
      //   media_id: 47,
      //   title: ""
      // });

    //  console.log('this.img');
    //  console.log(this.img);
    //  console.log(this.img.imgList[0].url);

      let tmpImgUrl = this.img.imgList[0].url;

      if(tmpImgUrl != '' && tmpImgUrl != null && typeof tmpImgUrl != 'undefined'){
        itemList[index].info[0].imgVideo.push({
          id: this.img.imgList[0].id,
          img: this.img.imgList[0].url,
          media_img: this.img.imgList[0].media_img,
          media_id: this.img.imgList[0].ctm_media,
          title: ""
        });

        // itemList[index].info[i].imgVideo.push({
        //   id: this.img.imgList[this.img.active].id,
        //   img: this.img.imgList[this.img.active].url,
        //   media_img: this.img.imgList[this.img.active].media_img,
        //   media_id: this.img.imgList[this.img.active].ctm_media,
        //   title: ""
        // });

        itemList[index].info[0].editType = "img";
      }
    },
    nextStep() {
    //  console.log('msg nextStep');
    //  console.log(this.msgGuideStep);
      // if (this.msgGuideStep === 735) {
      //   axios
      //     .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
      //       s_code: this.$route.params.id,
      //       id: this.msgTeaching_id,
      //       campaign_id: this.campaignId,
      //       campaign_objective: this.goalsObjective,
      //       skip: 1,
      //       step: this.msgGuideStep,
      //       active: ''
      //     }))
      //     .then((response) => {
      //       if(response.data.teaching_status == 'Y'){
      //       //  console.log('teaching_status Y');
      //         this.msgTeaching_id = 0;
      //         this.msgTeachingOverData = 1;
      //         this.$emit('childMsgTeachingOver', 1);
      //       }
      //       this.msgGuideStep = -1;
      //       this.$router.push({ query: { step: this.msgGuideStep, msgguide: false }});
      //     });
      // } else {
      //   axios
      //     .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
      //       s_code: this.$route.params.id,
      //       id: this.msgTeaching_id,
      //       campaign_id: this.campaignId,
      //       campaign_objective: this.goalsObjective,
      //       skip: 0,
      //       step: this.msgGuideStep,
      //       active: ''
      //     }))
      //     .then((response) => {
      //       this.msgGuideStep = this.msgGuideStep + 1;
      //       this.$router.push({ query: { step: this.msgGuideStep }});
      //     });
      // }
    },
    closeTips() {
    //  console.log('closeTips');
    //  console.log(this.msgGuideStep);

      let skip = 0;
      let skip_target = [701, 735];
      for(let i = 0; i < skip_target.length; i++){
        if(this.msgGuideStep == skip_target[i]){
          skip = 1;
        }
      }
      // if(this.nowStep == 70){
      //   skip = 1;
      // }

      // axios
      //   .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
      //     s_code: this.$route.params.id,
      //     id: this.msgTeaching_id,
      //     campaign_id: this.campaignId,
      //     campaign_objective: this.goalsObjective,
      //     skip: skip,
      //     step: this.msgGuideStep,
      //     active: ''
      //   }))
      //   .then((response) => {
      //     if(response.data.teaching_status == 'Y'){
      //       this.msgTeaching_id = 0;
      //       this.msgTeachingOverData = 1;
      //       this.$emit('childMsgTeachingOver', 1);
      //     }

      //     this.msgGuideStep = -1;
      //     this.$router.push({ query: { step: this.msgGuideStep }});
      //   });
    },
    // <!-- 新手教學 -->
    selectImg(index, type){
      if(type == 'api'){
        this.img.active = null;
        this.img.activeApi = index;
      } else {
        this.img.active = index;
        this.img.activeApi = null;
      }
    },
    selectVideo(index, type){
      if(type == 'api'){
        this.video.active = null;
        this.video.activeApi = index;
      } else {
        this.video.active = index;
        this.video.activeApi = null;
      }
    },
    changeSelectItem(value){
      this.selectedItem = value;

      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;

      this.$emit('childChangeMessageId', get_value);
      this.$emit('childAdIsChangeData', true);
    //  console.log('this.messageList');
    //  console.log(this.messageList);
      for (let i = 0; i < this.messageList.length; i++) {
        if (this.messageList[i].id === value) {
        //  console.log(this.messageList[i].status);
          if(this.messageList[i].status == 'formal' || this.messageList[i].status == 'formal_zh_cn'){
            // console.log('正式');
            this.editType = 1
            break;
          } else {
            // console.log('草稿');
            this.editType = 2
            break;
          }
        }
      }

    //  console.log('this.editType');
    //  console.log(this.editType);
    },
    activeImmediate(value, type){
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        if(value != ''){

          this.view_type = type

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_view.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: this.pageId,
              id: value
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                // this.msgBox = response.data.return_data
                // console.log('b this.msgBox');
                // console.log(this.msgBox);

              //  console.log('b this.nodeId');
              //  console.log(this.nodeId);

                this.messageName = response.data.name
                if(type == 'copy'){
                  var today = new Date();
                  var year = today.getFullYear();
                  var month = (today.getMonth()<10 ? '0' : '')+(today.getMonth()+1);
                  var date = (today.getDate()<10 ? '0' : '')+today.getDate();
                  var hour = (today.getHours()<10 ? '0' : '')+today.getHours();
                  var min = (today.getMinutes()<10 ? '0' : '')+today.getMinutes();
                  var sec = (today.getSeconds()<10 ? '0' : '')+today.getSeconds();
                  var currentDateTime = year +'/'+ month +'/'+ date +' '+ hour +':'+ min + ':' + sec;
                  this.messageName = this.lang['views']['Msg']['methods']['activeImmediate']['messageName'] + currentDateTime;
                }

                this.msgBox = response.data.return_data
                this.nodeId = response.data.btn_max_id

              //  console.log('activeImmediate a this.msgBox');
              //  console.log(this.msgBox);

              //  console.log('a this.nodeId');
              //  console.log(this.nodeId);

                // this.bezierRefresh();
                // var t = this;
                // setTimeout(() => {
                //   t.bezierRefresh();
                // }, 150);

                setTimeout(() => {
                  // 更新貝茲曲線
                  // eslint-disable-next-line no-undef
                  $(".element").bezierRefresh();
                }, 500);

                this.setMsgActive(0, 0, 'first');

                this.showModal = true
              }
            });
        }
      } else {
        Swal.fire(
                  this.lang['views']['Msg']['methods']['activeImmediate']['swal_title'],
                  this.lang['views']['Msg']['methods']['activeImmediate']['swal_text'],
                  'error'
                )
      }
    },
    save(){
    //  console.log('save');
    //  console.log(this.msgBox);

      let formData = this.msgBox
      let messageName = this.messageName

      // if(this.editPageType == false){
        if(messageName != '' && messageName != null && typeof messageName != 'undefined'){
        //  console.log('#1');
          axios
            .post('https://www.autoturn.net/api/customize/data/message_update.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: this.pageId,
              name: messageName,
              form_data: formData,
              type: this.view_type
            }))
            .then((response) => {
            //  console.log(response.data);
              if(response.data.status == 'success'){
                    Swal.fire({
                      icon: response.data.status,
                      title: this.lang['views']['Msg']['methods']['save']['swal_title'],
                      text: response.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.lang['views']['Msg']['methods']['save']['confirm_button'],
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        this.showMsgList = true;
                        this.showModal = false
                        // Swal.fire('Saved!', '', 'success')
                        axios
                          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                          }))
                          .then((wmResponse) => {
                            if(wmResponse.data.status == 'success'){
                              // console.log('b this.messageList');
                              // console.log(this.messageList);

                              this.messageList = wmResponse.data.return_data

                              // console.log('a this.messageList');
                              // console.log(this.messageList);
                              this.showMsgList = false
                            }
                          });
                      } else if (result.isDenied) {
                        this.showMsgList = true;
                        this.showModal = false
                        // Swal.fire('Changes are not saved', '', 'info')
                        axios
                          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                          }))
                          .then((wmResponse) => {
                            if(wmResponse.data.status == 'success'){
                              // console.log('b this.messageList');
                              // console.log(this.messageList);

                              this.messageList = wmResponse.data.return_data

                              // console.log('a this.messageList');
                              // console.log(this.messageList);
                              this.showMsgList = false
                            }
                          });
                      }
                    })
                // this.immediateList = response.data.return_data
                // this.formData = response.data.return_data.form

                // if(type == 1){
                //   var todayForm = new Date();
                //   var yearForm = todayForm.getFullYear();
                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                //   this.formTitle = 'title_'+todayForm;
                // } else {
                //   this.formTitle = response.data.return_data.name;
                // }

                // this.showModal = true
              } else {
                Swal.fire(
                          this.lang['views']['Msg']['methods']['save']['swal_title'],
                          response.data.info,
                          response.data.status
                        )
              }
            });

        } else {
        //  console.log('#2');
          Swal.fire(
                      this.lang['views']['Msg']['methods']['save']['swal_title'],
                      this.lang['views']['Msg']['methods']['save']['swal_text'],
                      "warning"
                    )
        }
      // }
    },
    openModal() {
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        this.messageName = '';
        this.msgBox = {
          item: [
            {
              id: 0,
              level: 0,
              isFirst: true,
              status:'first',
              info: [
                {
                  id: 2,
                  editType: 'text',
                  content: this.lang['views']['Msg']['methods']['openModal']['msgBox_item_info_content'],
                  btn: [],
                  imgVideo: [],
                  type: "content"
                }
              ],
              fast: []
            }
          ],
          sub: {}
        };
        this.setMsgActive(0, 0, 'first');
        this.showModal = true;

        var t = this;
        setTimeout(() => {
          t.bezierRefresh();
        }, 150);
        // <!-- 新手教學 -->
      //  console.log('this.useTeachDetail');
      //  console.log(this.useTeachDetail);
      //  console.log('this.msgTeachingOverData');
      //  console.log(this.msgTeachingOverData);
      //  console.log('this.msgGuide');
      //  console.log(this.msgGuide);
        if(this.useTeachDetail == true && this.msgTeachingOverData == 0 && this.targetAllSkip == 0){
          // axios
          //   .post('https://www.autoturn.net/api/data/teaching_create.php', Qs.stringify({
          //     s_code: this.$route.params.id,
          //     step: 701
          //   }))
          //   .then((response) => {
          //     this.msgTeaching_id = response.data.id;
          //     this.msgGuideStep = 701;
          //     this.$router.push({ query: { step: this.msgGuideStep }});
          //   });

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: this.pageId,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                this.img = {
                  imgList: response.data.return_data,
                  imgListApi: response.data.return_data_api
                }
              }
            });
        }
      } else {
        Swal.fire(
                  this.lang['views']['Msg']['methods']['openModal']['swal_title'],
                  this.lang['views']['Msg']['methods']['openModal']['swal_text'],
                  'error'
                )
      }
      // <!-- 新手教學 -->
    },
    setMsgActive(id, level, status) {
      this.msgActive.id = id;
      this.msgActive.level = level;
      this.msgActive.status = status;

      // console.log(this.msgActive.id+':'+this.msgActive.level);
    },
    openContentTypeWindows(id, editType, btnLength) {
    //  console.log('id:'+id);
    //  console.log('editType:'+editType);
    //  console.log('btnLength:'+btnLength);
    //  console.log('this.msgBox:');
    //  console.log(this.msgBox);
      this.showContentTypeWindows = true;
      this.contentInfoTypeWindowsId = id;
      this.nodeBottonNum = btnLength
      this.contentInfoTypeWindowsEditType = editType;
    },
    openContentInfoBtn(id, bId) {
      this.showContentTypeWindows = false;
      this.showContentWindows = true;
      this.contentInfoBtn.text = "";
      this.contentInfoBtn.url = "";
      this.contentInfoBtn.phone = "";
      this.contentInfoBtn.active = 1;
      this.contentInfoBtn.contentId = id;
      this.contentInfoBtn.btnId = null;

    //  console.log('openContentInfoBtn this.contentInfoBtn');
    //  console.log(this.contentInfoBtn);
    //  console.log(bId);
    //  console.log('openContentInfoBtn var this.msgBox');
    //  console.log(this.msgBox);

      if (bId != null) {
        this.contentInfoBtn.btnId = bId;
        var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      //  console.log('openContentInfoBtn this.msgBox');
      //  console.log(this.msgBox);

        for (let i = 0; i < itemList.length; i++) {
          if (
            itemList[i].id == this.msgActive.id &&
            itemList[i].info.length > 0
          ) {
            for (let j = 0; j < itemList[i].info.length; j++) {
              if (itemList[i].info[j].id == id) {
                for (let b = 0; b < itemList[i].info[j].btn.length; b++) {
                  if (itemList[i].info[j].btn[b].id == bId) {
                    this.contentInfoBtn.text = itemList[i].info[j].btn[b].text;
                    this.contentInfoBtn.url = itemList[i].info[j].btn[b].url;
                    this.contentInfoBtn.phone =
                      itemList[i].info[j].btn[b].phone;
                    this.contentInfoBtn.active =
                      itemList[i].info[j].btn[b].type;

                    break;
                  }
                }
                break;
              }
            }
            break;
          }
        }
      }
    },
    openMsgBoxImg(id, editType) {
      // console.log('openMsgBoxImg');
      // if(this.editPageType == false){
        this.showImgWindows = true;
        this.showImgLoading = false;
        this.img = {
          imgList: [],
          imgListApi: []
        }

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
            s_code: this.$route.params.id,
            page_id: this.pageId,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.img = {
                imgList: response.data.return_data,
                imgListApi: response.data.return_data_api
              }
            }

            this.showContentTypeWindows = false;
            this.showImgLoading = true

            if (id != null) this.contentInfoTypeWindowsId = id;
            else this.contentInfoTypeWindowsId = null;

            if (editType != null) this.contentInfoTypeWindowsEditType = editType;
            else this.contentInfoTypeWindowsEditType = null;
          });
      // }
    },
    openMsgBoxVideo(id, editType) {
      // console.log('openMsgBoxVideo');
      // if(this.editPageType == false){
        this.showVideoWindows = true;
        this.showVideoLoading = false;
        this.video = {
          videoList: [],
          videoListApi: []
        }

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
            s_code: this.$route.params.id,
            page_id: this.pageId,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.video = {
                videoList: response.data.return_data,
                videoListApi: response.data.return_data_api
              }
            }

            this.showContentTypeWindows = false;
            this.showVideoLoading = true

            if (id != null) this.contentInfoTypeWindowsId = id;
            else this.contentInfoTypeWindowsId = null;

            if (editType != null) this.contentInfoTypeWindowsEditType = editType;
            else this.contentInfoTypeWindowsEditType = null;
          });
      // }
    },
    getMsgLevelItem(msgBox, level) {
      // console.log('getMsgLevelItem:'+level);
      if (level > 0) {
        // console.log('level > 0');
        if (msgBox.sub) {
          // console.log(this.getMsgLevelItem(msgBox.sub, level - 1));
          return this.getMsgLevelItem(msgBox.sub, level - 1);
        } else {
          // console.log('null');
          return null;
        }
      } else {
        // console.log('level == 0');
        // console.log(msgBox.item);
        return msgBox.item;
      }
    },
    getMsgLevelMsgBox(msgBox, level) {
      if (level > 0) {
        if (msgBox.sub) {
          return this.getMsgLevelMsgBox(msgBox.sub, level - 1);
        } else {
          return null;
        }
      } else {
        return msgBox;
      }
    },
    getMsgBoxItemIndex(itemList, id) {
      let index = null;
      for (let i = 0; i < itemList.length; i++) {
        if (itemList[i].id == id) {
          index = i;

          break;
        }
      }

      return index;
    },
    getMsgBoxMaxId(list) {
      // let id = 0;
      let id = this.nodeId;
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          if (id < list[i].id) {
            id = list[i].id;
          }
        }

        id += 1;

        this.nodeId = id
      }

      return id;
    },
    setNewNode(){
      // let msgBox = this.msgBox
      this.contentInfoBtn.active = 1;

    //  console.log('setNewNode b this.msgBox');
    //  console.log(this.msgBox);
      // console.log('setNewNode b msgBox');
      // console.log(msgBox);
    //  console.log('setNewNode b this.msgActive');
    //  console.log(this.msgActive);

      this.setMsgBoxItemBtn(this.msgBox);
    },
    IsURL(str_url){
    //  console.log('str_url');
    //  console.log(str_url);
      // var strRegex = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
      // // var strRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
      // // var strRegex = /^(http|https):\/\/[\w\-_\u4E00-\u9FA5:/]+(\.[\w\-_\u4E00-\u9FA5]+)+([\u4E00-\u9FA5\w\-.,@?^=%&:/~+#]*[\u4E00-\u9FA5\w\-@?^=%&/~+#])?$/;
      // var re = new RegExp(strRegex);
      // //re.test()
      // if (re.test(str_url)){
      // //  console.log('#1');
        return true;
      // } else {
      // //  console.log('#2');
      //   return false;
      // }
    },
    setMsgBoxItemBtn(msgBox) {
      //btnId 重複
      let id = this.contentInfoBtn.contentId;
      let bId = this.contentInfoBtn.btnId;
      let url_safe = 1;
    //  console.log('setMsgBoxItemBtn let b this.msgBox');
    //  console.log(this.msgBox);
    //  console.log('setMsgBoxItemBtn let b this.msgActive');
    //  console.log(this.msgActive);

    //  console.log('setMsgBoxItemBtn b this.msgBox');
    //  console.log(this.msgBox);

    //  console.log('setMsgBoxItemBtn b msgBox');
    //  console.log(msgBox);

      let tmp_msgBox = this.msgBox
      if(msgBox != '' && msgBox != null && typeof msgBox != 'undefined'){
        tmp_msgBox = msgBox
      }

      var msgBox = this.getMsgLevelMsgBox(tmp_msgBox, this.msgActive.level);
      var itemList = this.getMsgLevelItem(tmp_msgBox, this.msgActive.level);

    //  console.log('setMsgBoxItemBtn b msgBox');
    //  console.log(msgBox);
    //  console.log('setMsgBoxItemBtn b itemList');
    //  console.log(itemList);

    //  console.log('this.contentInfoBtn');
    //  console.log(this.contentInfoBtn);

      // if(this.editPageType == false){
        for (let i = 0; i < itemList.length; i++) {
          if (
            itemList[i].id == this.msgActive.id &&
            itemList[i].info.length > 0
          ) {
            for (let j = 0; j < itemList[i].info.length; j++) {
              if (itemList[i].info[j].id == id) {
                if (bId == null) {
                  // let btnId = this.getMsgBoxMaxId(itemList[i].info[j].btn);
                  let btnId = this.nodeId;
                  if(itemList[i].info[j].btn.length < 3){
                    let node_url = this.contentInfoBtn.url
                    if(node_url != '' && node_url != null && typeof node_url != 'undefined'){
                      if(this.IsURL(node_url) == false){
                        Swal.fire(
                          this.lang['views']['Msg']['methods']['setMsgBoxItemBtn']['url_format_error_swal_title'],
                          this.lang['views']['Msg']['methods']['setMsgBoxItemBtn']['url_format_error_swal_text'],
                          "error"
                        )

                        url_safe = 0;

                        break;
                      }
                    }

                    itemList[i].info[j].btn.push({
                      id: btnId,
                      text: this.contentInfoBtn.text,
                      url: this.contentInfoBtn.url,
                      phone: this.contentInfoBtn.phone,
                      type: this.contentInfoBtn.active
                    });

                    let randInt = Math.floor((Math.random() * (110-100)) +100);

                    this.nodeId = parseInt(btnId) + parseInt(randInt);
                  //  console.log('setMsgBoxItemBtn nodeId');
                  //  console.log(this.nodeId);
                  //  console.log('setMsgBoxItemBtn btnId');
                  //  console.log(btnId);

                    if (!msgBox.sub || !msgBox.sub.item || !msgBox.sub.sub) {
                      msgBox.sub = {
                        item: [],
                        sub: {}
                      };
                    }

                    let insertIndex = 0;
                    for (
                      insertIndex;
                      insertIndex < msgBox.sub.item.length;
                      insertIndex++
                    ) {
                      if (msgBox.sub.item[insertIndex].parentFast != null) {
                        break;
                      }
                    }

                    if(this.contentInfoBtn.active == 1){
                      let infoId = this.nodeId
                      msgBox.sub.item.splice(insertIndex, 0, {
                        id: this.getMsgBoxMaxId(msgBox.sub.item),
                        level: this.msgActive.level + 1,
                        parent: this.msgActive.id,
                        parentInfo: id,
                        parentInfoBtn: btnId,
                        status:'general',
                        info: [
                          {
                            id: infoId,
                            editType: 'text',
                            content: this.lang['views']['Msg']['methods']['setMsgBoxItemBtn']['msgBox_item_info_content'],
                            btn: [],
                            imgVideo: [],
                            type: "content"
                          }
                        ],
                        fast: []
                      });
                    }
                  }
                } else {
                  for (let b = 0; b < itemList[i].info[j].btn.length; b++) {
                    if (itemList[i].info[j].btn[b].id == bId) {
                      let node_url = this.contentInfoBtn.url
                      if(node_url != '' && node_url != null && typeof node_url != 'undefined'){
                        if(this.IsURL(node_url) == false){
                          Swal.fire(
                            this.lang['views']['Msg']['methods']['setMsgBoxItemBtn']['url_format_error_swal_title'],
                            this.lang['views']['Msg']['methods']['setMsgBoxItemBtn']['url_format_error_swal_text'],
                            "error"
                          )

                          url_safe = 0;

                          break;
                        }
                      }

                      itemList[i].info[j].btn[b].text = this.contentInfoBtn.text;
                      itemList[i].info[j].btn[b].url = this.contentInfoBtn.url;
                      itemList[i].info[j].btn[
                        b
                      ].phone = this.contentInfoBtn.phone;
                      itemList[i].info[j].btn[
                        b
                      ].type = this.contentInfoBtn.active;

                      break;
                    }
                  }
                }
              }
            }
            break;
          }
        }
        // console.log('itemList');3
        if(url_safe == 1){
          this.showContentWindows = false;
        }
      // }

    //  console.log('setMsgBoxItemBtn a this.msgBox');
    //  console.log(this.msgBox);
    //  console.log('setMsgBoxItemBtn a msgBox');
    //  console.log(msgBox);
    //  console.log('setMsgBoxItemBtn a itemList');
    //  console.log(itemList);

      this.bezierRefresh();
    },
    setMsgBoxItemFast(tmp_text, tmp_content) {
      var msgBox = this.getMsgLevelMsgBox(this.msgBox, this.msgActive.level);
      var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);

    //  console.log('tmp_text');
    //  console.log(tmp_text);

      let textLabel = '';
      if(tmp_text != '' && tmp_text != null && typeof tmp_text != 'undefined'){
        textLabel = tmp_text;
      }

    //  console.log('textLabel');
    //  console.log(textLabel);

    //  console.log('tmp_content');
    //  console.log(tmp_content);

      let contentLabel = this.lang['views']['Msg']['methods']['setMsgBoxItemFast']['msgBox_item_info_content'];
      if(tmp_content != '' && tmp_content != null && typeof tmp_content != 'undefined'){
        contentLabel = tmp_content;
      }

    //  console.log('contentLabel');
    //  console.log(contentLabel);

      // if(this.editPageType == false){
        for (let i = 0; i < itemList.length; i++) {
          if (itemList[i].id == this.msgActive.id) {
            // let fastId = this.getMsgBoxMaxId(itemList[i].fast);
            let fastId = this.nodeId;
            itemList[i].fast.push({
              id: fastId,
              text: textLabel
            });

            this.nodeId = parseInt(fastId) + parseInt(1);

            if (!msgBox.sub || !msgBox.sub.item || !msgBox.sub.sub) {
              msgBox.sub = {
                item: [],
                sub: {}
              };
            }

            let itemId = this.nodeId
            msgBox.sub.item.push({
              id: this.getMsgBoxMaxId(msgBox.sub.item),
              level: this.msgActive.level + 1,
              parent: this.msgActive.id,
              parentFast: fastId,
              status:'fast',
              info: [
                {
                  id: itemId,
                  editType: "text",
                  content: contentLabel,
                  btn: [],
                  imgVideo: [],
                  type: "content"
                }
              ],
              fast: []
            });

            break;
          }
        }
      // }

      this.bezierRefresh();
    },
    setMsgBoxContent() {
      var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);
      // if(this.editPageType == false){
        itemList[index].info.push({
          id: this.getMsgBoxMaxId(itemList[index].info),
          content: "",
          btn: [],
          imgVideo: [],
          editType: "text",
          type: "content"
        });
      // }
    },
    setMsgBoxImg() {
      // if(this.editPageType == false){
        if (
          this.img.active != null &&
          this.img.imgList.length > this.img.active
        ) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

          if (this.contentInfoTypeWindowsId != null) {
            for (let i = 0; i < itemList[index].info.length; i++) {
              if (itemList[index].info[i].id === this.contentInfoTypeWindowsId) {
                itemList[index].info[i].imgVideo = [];

                itemList[index].info[i].imgVideo.push({
                  id: this.img.imgList[this.img.active].id,
                  img: this.img.imgList[this.img.active].url,
                  media_img: this.img.imgList[this.img.active].media_img,
                  media_id: this.img.imgList[this.img.active].ctm_media,
                  title: ""
                });

                itemList[index].info[i].editType = "img";
                break;
              }
            }
          } else {
            itemList[index].info.push({
              id: this.getMsgBoxMaxId(itemList[index].info),
              img_id: this.img.imgList[this.img.active].id,
              img: this.img.imgList[this.img.active].url,
              media_img: this.img.imgList[this.img.active].media_img,
              media_id: this.img.imgList[this.img.active].ctm_media,
              type: "img",
              editType: "img",
              title: "",
              btn: []
            });
          }
        }

        if (
          this.img.activeApi != null &&
          this.img.imgListApi.length > this.img.activeApi
        ) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

          if (this.contentInfoTypeWindowsId != null) {
            for (let i = 0; i < itemList[index].info.length; i++) {
              if (itemList[index].info[i].id === this.contentInfoTypeWindowsId) {
                itemList[index].info[i].imgVideo = [];

                itemList[index].info[i].imgVideo.push({
                  id: this.img.imgListApi[this.img.activeApi].id,
                  img: this.img.imgListApi[this.img.activeApi].url,
                  media_img: this.img.imgListApi[this.img.activeApi].media_img,
                  media_id: this.img.imgListApi[this.img.activeApi].ctm_media,
                  title: ""
                });

                itemList[index].info[i].editType = "img";
                break;
              }
            }
          } else {
          //  console.log('this.img');
          //  console.log(this.img);
          //  console.log('this.img.activeApi');
          //  console.log(this.img.activeApi);
            itemList[index].info.push({
              id: this.getMsgBoxMaxId(itemList[index].info),
              img_id: this.img.imgListApi[this.img.activeApi].id,
              img: this.img.imgListApi[this.img.activeApi].url,
              media_img: this.img.imgListApi[this.img.activeApi].media_img,
              media_id: this.img.imgListApi[this.img.activeApi].ctm_media,
              type: "img",
              editType: "img",
              title: "",
              btn: []
            });
          }
        }

        // console.log('setMsgBoxImg itemList');
        // console.log(itemList);

        this.img.active = null;
        this.img.activeApi = null;
        this.showImgWindows = false;
      // }

      this.bezierRefresh();
    },
    setMsgBoxVideo() {
    //  console.log('setMsgBoxVideo');
      // if(this.editPageType == false){
        if (
          this.video.active != null &&
          this.video.videoList.length > this.video.active
        ) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

          if (this.contentInfoTypeWindowsId != null) {
            for (let i = 0; i < itemList[index].info.length; i++) {
              if (itemList[index].info[i].id === this.contentInfoTypeWindowsId) {
                itemList[index].info[i].imgVideo = [];

                itemList[index].info[i].imgVideo.push({
                  id: this.video.videoList[this.video.active].id,
                  video: this.video.videoList[this.video.active].url,
                  media: this.video.videoList[this.video.active].media,
                  media_id: this.video.videoList[this.video.active].ctm_media,
                  title: ""
                });

                itemList[index].info[i].content = "";
                itemList[index].info[i].editType = "video";
                break;
              }
            }
          } else {
            itemList[index].info.push({
              id: this.getMsgBoxMaxId(itemList[index].info),
              video_id: this.video.videoList[this.video.active].id,
              video: this.video.videoList[this.video.active].url,
              media: this.video.videoList[this.video.active].media,
              media_id: this.video.videoList[this.video.active].ctm_media,
              type: "video",
              editType: "video",
              title: "",
              btn: []
            });
          }
        }

        if (
          this.video.activeApi != null &&
          this.video.videoListApi.length > this.video.activeApi
        ) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

          if (this.contentInfoTypeWindowsId != null) {
            for (let i = 0; i < itemList[index].info.length; i++) {
              if (itemList[index].info[i].id === this.contentInfoTypeWindowsId) {
                itemList[index].info[i].imgVideo = [];

                itemList[index].info[i].imgVideo.push({
                  id: this.video.videoListApi[this.video.activeApi].id,
                  video: this.video.videoListApi[this.video.activeApi].url,
                  media: this.video.videoListApi[this.video.activeApi].media,
                  media_id: this.video.videoListApi[this.video.activeApi].ctm_media,
                  title: ""
                });

                itemList[index].info[i].content = "";
                itemList[index].info[i].editType = "video";
                break;
              }
            }
          } else {
            itemList[index].info.push({
              id: this.getMsgBoxMaxId(itemList[index].info),
              video_id: this.video.videoListApi[this.video.activeApi].id,
              video: this.video.videoListApi[this.video.activeApi].url,
              media: this.video.videoListApi[this.video.activeApi].media,
              media_id: this.video.videoListApi[this.video.activeApi].ctm_media,
              type: "video",
              editType: "video",
              title: "",
              btn: []
            });
          }
        }

      //  console.log('setMsgBoxVideo itemList');
      //  console.log(itemList);

        this.video.active = null;
        this.video.activeApi = null;
        this.showVideoWindows = false;
      // }

      this.bezierRefresh();
    },
    removeMsgBoxConfirmed(id, level) {
      var t = this;

      // if(this.editPageType == false){
        this.$swal
          .fire({
            text: this.lang['views']['Msg']['methods']['removeMsgBoxConfirmed']['swal_title'],
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#1D619F",
            confirmButtonText: this.lang['views']['Msg']['methods']['removeMsgBoxConfirmed']['confirm_button']
          })
          .then(result => {
            if (result.isConfirmed) {
              t.removeMsgBox(id, level);
            }
          });
        // }
    },
    removeMsgBox(id, level) {
      var itemList = this.getMsgLevelItem(this.msgBox, level);
      let index = this.getMsgBoxItemIndex(itemList, id);

      // if(this.editPageType == false){
        this.removeMsgBoxParent(level - 1, {
          id: itemList[index].parent,
          info: itemList[index].parentInfo,
          infoBtn: itemList[index].parentInfoBtn,
          fast: itemList[index].parentFast
        });

      //  console.log('itemList['+index+'].info');
      //  console.log(itemList[index].info);
      //  console.log('itemList['+index+'].fast');
      //  console.log(itemList[index].fast);

        if(itemList[index].info != '' && itemList[index].info != null && typeof itemList[index].info != 'undefined'){
          for (let i = 0; i < itemList[index].info.length; i++) {
            if(itemList[index].info[i].btn != '' && itemList[index].info[i].btn != null && typeof itemList[index].info[i].btn != 'undefined'){
              for (let j = 0; j < itemList[index].info[i].btn.length; j++) {
                this.removeMsgBoxSub(level + 1, {
                  id: id,
                  info: itemList[index].info[i].id,
                  infoBtn: itemList[index].info[i].btn[j].id
                });
              }
            }
          }
        }

        if(itemList[index].fast != '' && itemList[index].fast != null && typeof itemList[index].fast != 'undefined'){
          for (let i = 0; i < itemList[index].fast.length; i++) {
            this.removeMsgBoxSub(level + 1, {
              id: id,
              fast: itemList[index].fast[i].id
            });
          }
        }

        if (index != null) {
          itemList.splice(index, 1);
          this.setMsgActive(0, 0, 'first');
        }
      // }

      this.bezierRefresh();
    },
    removeMsgBoxParent(level, parent) {
      var itemList = this.getMsgLevelItem(this.msgBox, level);
      let index = this.getMsgBoxItemIndex(itemList, parent.id);

      // if(this.editPageType == false){
        if (
          itemList[index].info.length > 0 &&
          parent.info != undefined &&
          parent.infoBtn != undefined
        ) {
          for (let i = 0; i < itemList[index].info.length; i++) {
            if (itemList[index].info[i].id == parent.info) {
              for (let j = 0; j < itemList[index].info[i].btn.length; j++) {
                if (itemList[index].info[i].btn[j].id == parent.infoBtn) {
                  itemList[index].info[i].btn.splice(j, 1);

                  break;
                }
              }
              break;
            }
          }
        } else if (itemList[index].fast.length > 0 && parent.fast != undefined) {
          for (let i = 0; i < itemList[index].fast.length; i++) {
            if (itemList[index].fast[i].id == parent.fast) {
              itemList[index].fast.splice(i, 1);

              break;
            }
          }
        }
      // }
    },
    removeMsgBoxSub(level, parent) {
      var itemList = this.getMsgLevelItem(this.msgBox, level);
      let removeList = [];

      // if(this.editPageType == false){
        if (itemList != null) {
          for (let i = 0; i < itemList.length; i++) {
            if (itemList[i].parent == parent.id) {
              if (
                parent.info != undefined &&
                parent.infoBtn != undefined &&
                itemList[i].parentInfo == parent.info &&
                itemList[i].parentInfoBtn == parent.infoBtn
              ) {
                removeList.push(i);
              } else if (
                parent.fast != undefined &&
                itemList[i].parentFast == parent.fast
              ) {
                removeList.push(i);
              }
            }
          }

          for (let r = removeList.length - 1; r >= 0; r--) {
            if(itemList[removeList[r]].info != '' && itemList[removeList[r]].info != null && typeof itemList[removeList[r]].info != 'undefined'){
              for (let i = 0; i < itemList[removeList[r]].info.length; i++) {
                if(itemList[removeList[r]].info[i].btn != '' && itemList[removeList[r]].info[i].btn != null && typeof itemList[removeList[r]].info[i].btn != 'undefined'){
                  for (
                    let j = 0;
                    j < itemList[removeList[r]].info[i].btn.length;
                    j++
                  ) {
                    this.removeMsgBoxSub(level + 1, {
                      id: itemList[removeList[r]].id,
                      info: itemList[removeList[r]].info[i].id,
                      infoBtn: itemList[removeList[r]].info[i].btn[j].id
                    });
                  }
                }
              }
            }

            if(itemList[removeList[r]].fast != '' && itemList[removeList[r]].fast != null && typeof itemList[removeList[r]].fast != 'undefined'){
              for (let i = 0; i < itemList[removeList[r]].fast.length; i++) {
                this.removeMsgBoxSub(level + 1, {
                  id: itemList[removeList[r]].id,
                  fast: itemList[removeList[r]].fast[i].id
                });
              }
            }

            itemList.splice(removeList[r], 1);
          }
        }
      // }
    },
    removeMsgBoxInfoConfirmed(id) {
      var t = this;

      // if(this.editPageType == false){
        this.$swal
          .fire({
            text: this.lang['views']['Msg']['methods']['removeMsgBoxInfoConfirmed']['swal_title'],
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#1D619F",
            confirmButtonText: this.lang['views']['Msg']['methods']['removeMsgBoxInfoConfirmed']['confirm_button']
          })
          .then(result => {
            if (result.isConfirmed) {
              t.removeMsgBoxInfo(id);
            }
          });
      // }
    },
    removeMsgBoxInfo(id) {
      var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

      // if(this.editPageType == false){
        for (let i = 0; i < itemList[index].info.length; i++) {
          if (itemList[index].info[i].id == id) {
            if (itemList[index].info[i].img != undefined) {
              itemList[index].info.splice(i, 1);
            } else if (itemList[index].info[i].video != undefined) {
              itemList[index].info.splice(i, 1);
            } else {
              for (let j = 0; j < itemList[index].info[i].btn.length; j++) {
                this.removeMsgBoxSub(this.msgActive.level + 1, {
                  id: itemList[index].id,
                  info: itemList[index].info[i].id,
                  infoBtn: itemList[index].info[i].btn[j].id
                });
              }
              itemList[index].info.splice(i, 1);
            }

            break;
          }
        }
      // }

      this.bezierRefresh();
    },
    removeMsgBoxFastConfirmed(id) {
      var t = this;

      // if(this.editPageType == false){
        this.$swal
          .fire({
            text: this.lang['views']['Msg']['methods']['removeMsgBoxFastConfirmed']['swal_title'],
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#1D619F",
            confirmButtonText: this.lang['views']['Msg']['methods']['removeMsgBoxFastConfirmed']['confirm_button']
          })
          .then(result => {
            if (result.isConfirmed) {
              t.removeMsgBoxFast(id);
            }
          });
      // }
    },
    removeMsgBoxFast(id) {
      var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

      // if(this.editPageType == false){
        for (let i = 0; i < itemList[index].fast.length; i++) {
          if (itemList[index].fast[i].id == id) {
            this.removeMsgBoxSub(this.msgActive.level + 1, {
              id: itemList[index].id,
              fast: itemList[index].fast[i].id
            });

            itemList[index].fast.splice(i, 1);

            break;
          }
        }
      // }

      this.bezierRefresh();
    },
    removeBotton(c_index, id, p_index){
      var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

    //  console.log('btn index:'+c_index);
    //  console.log('info index:'+p_index);
    //  console.log('id:'+id);
    //  console.log('msgBox:');
    //  console.log(this.msgBox.item);
    //  console.log('itemList:');
    //  console.log(itemList);
    //  console.log('index:');
    //  console.log(index);

      let btn_text = itemList[index].info[p_index].btn[c_index].text

      this.$swal
        .fire({
          text: this.lang['views']['Msg']['methods']['removeBotton']['swal_title_a']+btn_text+this.lang['views']['Msg']['methods']['removeBotton']['swal_title_b'],
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#1D619F",
          confirmButtonText: this.lang['views']['Msg']['methods']['removeBotton']['confirm_button']
        })
        .then(result => {
          if (result.isConfirmed) {
            itemList[index].info[p_index].btn.splice(c_index, 1);
          }
        });
    },
    swapMsgInfo(index1, index2) {
      // if(this.editPageType == false){
        if (index2 >= 0) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          for (let i = 0; i < itemList.length; i++) {
            if (
              itemList[i].id == this.msgActive.id &&
              index2 < itemList[i].info.length
            ) {
              itemList[i].info = this.swapItems(itemList[i].info, index1, index2);
              break;
            }
          }
        }
      // }

      this.bezierRefresh();
    },
    swapMsgInfoBtn(index1, index2, btn_id) {
      // if(this.editPageType == false){
      //  console.log('swapMsgInfoBtn');
      //  console.log('index1:'+index1);
      //  console.log('index2:'+index2);

      //  console.log('btn_id');
      //  console.log(btn_id);

      //  console.log('swapMsgInfoBtn this.contentInfoBtn');
      //  console.log(this.contentInfoBtn);

        if (index2 >= 0) {
          let id = btn_id;//this.contentInfoBtn.contentId;
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);

        //  console.log('b id');
        //  console.log(id);
        //  console.log('itemList');
        //  console.log(itemList);

          // if(id == '' || id == null || typeof id == 'undefined'){
          //   id = btn_id;
          //   this.contentInfoBtn.contentId = btn_id
          // }

        //  console.log('a id');
        //  console.log(id);

        //  console.log('this.msgActive');
        //  console.log(this.msgActive);

          for (let i = 0; i < itemList.length; i++) {
          //  console.log('itemList['+i+'].id');
          //  console.log(itemList[i].id);
          //  console.log('itemList['+i+'].info');
          //  console.log(itemList[i].info);

            if (
              itemList[i].id == this.msgActive.id &&
              itemList[i].info.length > 0
            ) {
            //  console.log('#1');

            //  console.log('itemList['+i+'].id');
            //  console.log(itemList[i].id);
              for (let j = 0; j < itemList[i].info.length; j++) {
              //  console.log('itemList['+i+'].info['+j+'].id');
              //  console.log(itemList[i].info[j].id);

              //  console.log('itemList['+i+'].info['+j+'].btn.length');
              //  console.log(itemList[i].info[j].btn.length);
              //  console.log(itemList[i].info[j].id +'=='+ id +'&&'+ index2 +'<'+ itemList[i].info[j].btn.length);

                if (
                  itemList[i].info[j].id == id &&
                  index2 < itemList[i].info[j].btn.length
                ) {
                //  console.log('#2');
                //  console.log('b itemList['+i+'].info['+j+'].id');
                //  console.log(itemList[i].info[j].id);
                //  console.log('b itemList['+i+'].info['+j+'].btn');
                //  console.log(itemList[i].info[j].btn);

                  itemList[i].info[j].btn = this.swapItems(
                    itemList[i].info[j].btn,
                    index1,
                    index2
                  );

                //  console.log('a itemList['+i+'].info['+j+'].btn');
                //  console.log(itemList[i].info[j].btn);

                  break;
                }
              }
              break;
            }
          }
        }
      // }

      this.bezierRefresh();
    },
    swapMsgFast(index1, index2) {
      // if(this.editPageType == false){
        if (index2 >= 0) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          for (let i = 0; i < itemList.length; i++) {
            if (
              itemList[i].id == this.msgActive.id &&
              index2 < itemList[i].fast.length
            ) {
              itemList[i].fast = this.swapItems(itemList[i].fast, index1, index2);
              break;
            }
          }
        }
      // }

      this.bezierRefresh();
    },
    swapItems(arr, index1, index2) {
      // if(this.editPageType == false){
        arr[index1] = arr.splice(index2, 1, arr[index1])[0];
        return arr;
      // }
    },
    bezierRefresh() {
      setTimeout(() => {
        // 更新貝茲曲線
        // eslint-disable-next-line no-undef
        $(".element").bezierRefresh();
      }, 0);
    },
    onImgUpload(event) {
    //  console.log('onImgUpload');
    //  console.log('event');
    //  console.log(event);
    //  console.log('event.target');
    //  console.log(event.target);
    //  console.log('event.target.files');
    //  console.log(event.target.files);
    //  console.log('event.target.files[0]');
    //  console.log(event.target.files[0]);
      // this.$emit('update:modelValue', event.target.files[0]);
      if(event.target.files[0] != '' && event.target.files[0] != null && typeof event.target.files[0] != 'undefined'){
        const permit_file = ['jpg','jpeg','gif','png','bmp','svg','webp','wmf','tiff','tif','svg'];

        var view_file_data = event.target.files[0];
        let file_name = event.target.files[0].name;
        let _tmp_file_extension = file_name.split('.');
        let file_extension = _tmp_file_extension[1].toLowerCase();

        let this_file_size = event.target.files[0].size;
        let file_size_limit = 25*1024*1024;

        let form_data = new FormData();
        form_data.append('s_code', this.$route.params.id);
        form_data.append('data_type', 'image');
        form_data.append('file', view_file_data);

      //  console.log(this_file_size +'<'+ file_size_limit);

        if(permit_file.indexOf(file_extension) != -1){
          if(this_file_size < file_size_limit){
            axios
              .post('https://www.autoturn.net/api/customize/campaign/campaign_form_messages_upload.php', form_data,{
                headers: {
                  "Content-Type": 'multipart/form-data'
                }
              })
              .then((response) => {
              //  console.log(response);
                if(response.data.status == 'success'){
                  Swal.fire({
                    icon: response.data.status,
                    title: this.lang['views']['Msg']['methods']['onImgUpload']['swal_title'],
                    text: response.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang['views']['Msg']['methods']['onImgUpload']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      axios
                        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          page_id: this.pageId,
                          type: 'update'
                        }))
                        .then((response) => {
                          if(response.data.status == 'success'){
                            this.img = {
                              imgList: response.data.return_data,
                              imgListApi: response.data.return_data_api
                            }

                            // this.showImgWindows = true;
                            // this.showContentTypeWindows = false;

                            // if (id != null) this.contentInfoTypeWindowsId = id;
                            // else this.contentInfoTypeWindowsId = null;

                            // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                            // else this.contentInfoTypeWindowsEditType = null;
                          }
                        });
                    } else if (result.isDenied) {
                      axios
                        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          page_id: this.pageId,
                          type: 'update'
                        }))
                        .then((response) => {
                          if(response.data.status == 'success'){
                            this.img = {
                              imgList: response.data.return_data,
                              imgListApi: response.data.return_data_api
                            }

                            // this.showImgWindows = true;
                            // this.showContentTypeWindows = false;

                            // if (id != null) this.contentInfoTypeWindowsId = id;
                            // else this.contentInfoTypeWindowsId = null;

                            // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                            // else this.contentInfoTypeWindowsEditType = null;
                          }
                        });
                    }
                  })
                } else {
                  Swal.fire(
                              this.lang['views']['Msg']['methods']['onImgUpload']['swal_title'],
                              response.data.info,
                              response.data.status
                            )
                }
              });
          } else {
            Swal.fire(
                        this.lang['views']['Msg']['methods']['onImgUpload']['swal_title'],
                        this.lang['views']['Msg']['methods']['onImgUpload']['upload_size_error_swal_text'],
                        "error"
                      )
          }
        } else {
          Swal.fire(
                      this.lang['views']['Msg']['methods']['onImgUpload']['swal_title'],
                      this.lang['views']['Msg']['methods']['onImgUpload']['upload_type_error_swal_text'],
                      "error"
                    )
        }
      } else {
        Swal.fire(
                    this.lang['views']['Msg']['methods']['onImgUpload']['swal_title'],
                    this.lang['views']['Msg']['methods']['onImgUpload']['upload_select_error_swal_text'],
                    "warning"
                  )
      }
    },

    onVideoUpload(event) {
    //  console.log('onVideoUpload');
    //  console.log('event');
    //  console.log(event);
    //  console.log('event.target');
    //  console.log(event.target);
    //  console.log('event.target.files');
    //  console.log(event.target.files);
    //  console.log('event.target.files[0]');
    //  console.log(event.target.files[0]);
      // this.$emit('update:modelValue', event.target.files[0]);

      if(event.target.files[0] != '' && event.target.files[0] != null && typeof event.target.files[0] != 'undefined'){
        const permit_file = ['mp4','avi','flv','wmv','mov','mkv','rm','rmvb','mpg','mpeg','3gp'];

        var view_file_data = event.target.files[0];
        let file_name = event.target.files[0].name;
        let _tmp_file_extension = file_name.split('.');
        let file_extension = _tmp_file_extension[1].toLowerCase();

        let this_file_size = event.target.files[0].size;
        let file_size_limit = 25*1024*1024;

        let form_data = new FormData();
        form_data.append('s_code', this.$route.params.id);
        form_data.append('data_type', 'image');
        form_data.append('file', view_file_data);

        if(permit_file.indexOf(file_extension) != -1){
          if(this_file_size < file_size_limit){
            axios
              .post('https://www.autoturn.net/api/customize/campaign/campaign_form_messages_upload.php', form_data,{
                headers: {
                  "Content-Type": 'multipart/form-data'
                }
              })
              .then((response) => {
              //  console.log(response);
                if(response.data.status == 'success'){
                  Swal.fire({
                    icon: response.data.status,
                    title: this.lang['views']['Msg']['methods']['onVideoUpload']['swal_title'],
                    text: response.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang['views']['Msg']['methods']['onVideoUpload']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      axios
                        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          page_id: this.pageId,
                          type: 'update'
                        }))
                        .then((response) => {
                          if(response.data.status == 'success'){
                            this.video = {
                              videoList: response.data.return_data,
                              videoListApi: response.data.return_data_api
                            }

                            // this.showVideoWindows = true;
                            // this.showContentTypeWindows = false;

                            // if (id != null) this.contentInfoTypeWindowsId = id;
                            // else this.contentInfoTypeWindowsId = null;

                            // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                            // else this.contentInfoTypeWindowsEditType = null;
                          }
                        });
                    } else if (result.isDenied) {
                      axios
                        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          page_id: this.pageId,
                          type: 'update'
                        }))
                        .then((response) => {
                          if(response.data.status == 'success'){
                            this.video = {
                              videoList: response.data.return_data,
                              videoListApi: response.data.return_data_api
                            }

                            // this.showVideoWindows = true;
                            // this.showContentTypeWindows = false;

                            // if (id != null) this.contentInfoTypeWindowsId = id;
                            // else this.contentInfoTypeWindowsId = null;

                            // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                            // else this.contentInfoTypeWindowsEditType = null;
                          }
                        });
                    }
                  })
                } else {
                  Swal.fire(
                              this.lang['views']['Msg']['methods']['onVideoUpload']['swal_title'],
                              response.data.info,
                              response.data.status
                            )
                }
              });
          } else {
            Swal.fire(
                        this.lang['views']['Msg']['methods']['onVideoUpload']['swal_title'],
                        this.lang['views']['Msg']['methods']['onVideoUpload']['upload_size_error_swal_text'],
                        "error"
                      )
          }
        } else {
          Swal.fire(
                      this.lang['views']['Msg']['methods']['onVideoUpload']['swal_title'],
                      this.lang['views']['Msg']['methods']['onVideoUpload']['upload_type_error_swal_text'],
                      "error"
                    )
        }
      } else {
        Swal.fire(
                    this.lang['views']['Msg']['methods']['onVideoUpload']['swal_title'],
                    this.lang['views']['Msg']['methods']['onVideoUpload']['upload_select_error_swal_text'],
                    "warning"
                  )
      }
    },
    deleteUpload(id, type){
    //  console.log('deleteUpload');
    //  console.log('id:'+id+'，type:'+type);

      if(id != '' && id != null && typeof id != 'undefined'){
        Swal.fire({
          title: this.lang['views']['Msg']['methods']['deleteUpload']['swal_title'],
          html: this.lang['views']['Msg']['methods']['deleteUpload']['id_swal_text'],
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.lang['views']['Msg']['methods']['deleteUpload']['yes_button'],
          cancelButtonText: this.lang['views']['Msg']['methods']['deleteUpload']['cancel_button'],
        }).then((result) => {
          if (result.isConfirmed) {
          //  console.log('yes');

            axios
              .post('https://www.autoturn.net/api/customize/campaign/campaign_form_messages_upload_delete.php', Qs.stringify({
                s_code: this.$route.params.id,
                media: id,
              }))
              .then((response) => {
              //  console.log(response.data);
                if(response.data.status == 'success'){
                  Swal.fire({
                    icon: response.data.status,
                    title: this.lang['views']['Msg']['methods']['deleteUpload']['swal_title'],
                    text: response.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang['views']['Msg']['methods']['deleteUpload']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      if(type == 'image'){
                        axios
                          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                            type: 'update'
                          }))
                          .then((response) => {
                            if(response.data.status == 'success'){
                              this.img = {
                                imgList: response.data.return_data,
                                imgListApi: response.data.return_data_api
                              }

                              // this.showImgWindows = true;
                              // this.showContentTypeWindows = false;

                              // if (id != null) this.contentInfoTypeWindowsId = id;
                              // else this.contentInfoTypeWindowsId = null;

                              // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                              // else this.contentInfoTypeWindowsEditType = null;
                            }
                          });
                      } else {
                        axios
                          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                            type: 'update'
                          }))
                          .then((response) => {
                            if(response.data.status == 'success'){
                              this.video = {
                                videoList: response.data.return_data,
                                videoListApi: response.data.return_data_api
                              }

                              // this.showVideoWindows = true;
                              // this.showContentTypeWindows = false;

                              // if (id != null) this.contentInfoTypeWindowsId = id;
                              // else this.contentInfoTypeWindowsId = null;

                              // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                              // else this.contentInfoTypeWindowsEditType = null;
                            }
                          });
                      }
                    } else if (result.isDenied) {
                      if(type == 'image'){
                        axios
                          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                            type: 'update'
                          }))
                          .then((response) => {
                            if(response.data.status == 'success'){
                              this.img = {
                                imgList: response.data.return_data,
                                imgListApi: response.data.return_data_api
                              }

                              // this.showImgWindows = true;
                              // this.showContentTypeWindows = false;

                              // if (id != null) this.contentInfoTypeWindowsId = id;
                              // else this.contentInfoTypeWindowsId = null;

                              // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                              // else this.contentInfoTypeWindowsEditType = null;
                            }
                          });
                      } else {
                        axios
                          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                            type: 'update'
                          }))
                          .then((response) => {
                            if(response.data.status == 'success'){
                              this.video = {
                                videoList: response.data.return_data,
                                videoListApi: response.data.return_data_api
                              }

                              // this.showVideoWindows = true;
                              // this.showContentTypeWindows = false;

                              // if (id != null) this.contentInfoTypeWindowsId = id;
                              // else this.contentInfoTypeWindowsId = null;

                              // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                              // else this.contentInfoTypeWindowsEditType = null;
                            }
                          });
                      }
                    }
                  })
                } else {
                  Swal.fire(
                              this.lang['views']['Msg']['methods']['deleteUpload']['swal_title'],
                              response.data.info,
                              response.data.status
                            )
                }
              });
          }
        });
      } else {
        Swal.fire(
                    this.lang['views']['Msg']['methods']['deleteUpload']['swal_title'],
                    this.lang['views']['Msg']['methods']['deleteUpload']['not_id_swal_text'],
                    "warning"
                  )
      }
    },
    imageUpdate(){
    //  console.log('imageUpdate');
      this.showImgWindows = true;
      this.showImgLoading = false;
      this.img = {
        imgList: [],
        imgListApi: []
      }

      axios
        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: this.pageId,
          type: 'update'
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.img = {
              imgList: response.data.return_data,
              imgListApi: response.data.return_data_api
            }
          }

          this.showImgLoading = true;
        });
    },
    videoUpdate(){
    //  console.log('videoUpdate');
      this.showVideoWindows = true;
      this.showVideoLoading = false;
      this.video = {
        videoList: [],
        videoListApi: []
      }

      axios
        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: this.pageId,
          type: 'update'
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.video = {
              videoList: response.data.return_data,
              videoListApi: response.data.return_data_api
            }
          }

          this.showVideoLoading = true;
        });
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    }
  },
};
</script>
